import PropTypes from "prop-types";
import { Media } from "solar/components/Media";
import ImageOrCloudfront from "helpers/ImageOrCloudfront";
import Container from "components/residency/Container";
import Markdown from "solar/components/Markdown";
import styles from "components/surfer_development/Hero.module.scss";

export default function Hero({ imagePort, imageLand, name, subtitle }) {
  return (
    <div className={styles.component}>
      <Media lessThan="lg">
        <ImageOrCloudfront
          image={imagePort}
          className={styles.image}
          altName={name}
          sizeTemplate="full"
          priority
        />
      </Media>
      <Media greaterThan="md">
        <ImageOrCloudfront
          image={imageLand}
          className={styles.image}
          altName={name}
          sizeTemplate="full"
          priority
        />
      </Media>
      <Container className={styles.container}>
        <div className={styles.center}>
          <h1 className={styles.name}>{name}</h1>
          {subtitle && (
            <div className={styles.subtitle}>
              <Markdown>{subtitle}</Markdown>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

Hero.propTypes = {
  imagePort: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  imageLand: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  name: PropTypes.node.isRequired,
  subtitle: PropTypes.string.isRequired,
};
